console.log("asdf");  

let Shuffle = window.Shuffle;

let allVisible = true;

let othersVisible = false;

class Gallery {
    constructor(element) {
        this.element = element;
        this.shuffle = new Shuffle(element, {
            itemSelector: '.picture-item',
            sizer: element.querySelector('.my-sizer-element'),
        });
        this.addShuffleEventListeners();
        this._activeFilters = [];
        this.addFilterButtons('.filter-options');

        // $('.btn-gallery').bind('click', function (e) {
        //     if($(this).hasClass('active')){
        //         $("#grid").addClass('all-items');
        //     }else{
        //         $("#grid").remvoeClass('all-items');
        //     }
        // }); 
        $('.btn-gallery').bind('click', function (e) {
            console.log('x'); 
            if($(this).hasClass('active')){
                $("#grid").removeClass('all-items');
            }else{
                $("#grid").addClass('all-items');
            }
        }); 

        if(allVisible){
            loadMore();
        }else {
            loadMoreClickNav();
        }    
    }

    addShuffleEventListeners() {
        this.shuffle.on(Shuffle.EventType.LAYOUT, (data) => {
            console.log('layout. data:', data);
        });
        this.shuffle.on(Shuffle.EventType.REMOVED, (data) => {
            console.log('removed. data:', data);
        });
    }

    addFilterButtons(filterButtonsWrapper) {
        const options = document.querySelector(filterButtonsWrapper);
        if (!options) {
            return;
        }

        const filterButtons = Array.from(options.children);
        const onClick = this._handleFilterClick.bind(this);
        filterButtons.forEach((button) => {
            button.addEventListener('click', onClick, false);
        });
    }

    _handleFilterClick(evt) {
        const btn = evt.currentTarget;
        const isActive = btn.classList.contains('active');
        const btnGroup = btn.getAttribute('data-group');

        this._removeActiveClassFromChildren(btn.parentNode);

        let filterGroup;
        if (isActive) {
            btn.classList.remove('active');
            filterGroup = Shuffle.ALL_ITEMS;
        } else {
            btn.classList.add('active');
            filterGroup = btnGroup;
        }

        this.shuffle.filter(filterGroup);
        if(filterGroup == Shuffle.ALL_ITEMS){
            allVisible = true;
        }else{
            allVisible = false;
        }
        if(allVisible){
            // setTimeout(function(){
                loadMore();
            // }, 250);
        }else {
            loadMoreClickNav();
        }  
    }

    _removeActiveClassFromChildren(parent) {
        const {children} = parent;
        for (let i = children.length - 1; i >= 0; i--) {
            children[i].classList.remove('active');
        }
    }

    _handleSearchKeyup(evt) {
        const searchText = evt.target.value.toLowerCase();
        this.shuffle.filter((element, shuffle) => {
            // If there is a current filter applied, ignore elements that don't match it.
            if (shuffle.group !== Shuffle.ALL_ITEMS) {
                // Get the item's groups.
                const groups = JSON.parse(element.getAttribute('data-groups'));
                const isElementInCurrentGroup = groups.indexOf(shuffle.group) !== -1;
                // Only search elements in the current group
                if (!isElementInCurrentGroup) {
                    return false;
                }
            }
            const titleElement = element.querySelector('.picture-item__title');
            const titleText = titleElement.textContent.toLowerCase().trim();
            return titleText.indexOf(searchText) !== -1;
            console.log(element);  
        });
    }
}

class GalleryVideo {
    constructor(element) {
        this.element = element;
        this.shuffle = new Shuffle(element, {
            itemSelector: '.picture-item',
            sizer: element.querySelector('.my-sizer-element'),
        });
        this.addShuffleEventListeners();
        this._activeFilters = [];
        this.addFilterButtons('.filter-options-video');
    }

    addShuffleEventListeners() {
        this.shuffle.on(Shuffle.EventType.LAYOUT, (data) => {
            console.log('layout. data:', data);
        });
        this.shuffle.on(Shuffle.EventType.REMOVED, (data) => {
            console.log('removed. data:', data);
        });
    }

    addFilterButtons(filterButtonsWrapper) {
        const options = document.querySelector(filterButtonsWrapper);
        if (!options) {
            return;
        }

        const filterButtons = Array.from(options.children);
        const onClick = this._handleFilterClick.bind(this);
        filterButtons.forEach((button) => {
            button.addEventListener('click', onClick, false);
        });
    }

    _handleFilterClick(evt) {
        const btn = evt.currentTarget;
        const isActive = btn.classList.contains('active');
        const btnGroup = btn.getAttribute('data-group');

        this._removeActiveClassFromChildren(btn.parentNode);

        let filterGroup;
        if (isActive) {
            btn.classList.remove('active');
            filterGroup = Shuffle.ALL_ITEMS;
        } else {
            btn.classList.add('active');
            filterGroup = btnGroup;
        }

        this.shuffle.filter(filterGroup);
    }

    _removeActiveClassFromChildren(parent) {
        const {children} = parent;
        for (let i = children.length - 1; i >= 0; i--) {
            children[i].classList.remove('active');
        }
    }

    _handleSearchKeyup(evt) {
        const searchText = evt.target.value.toLowerCase();
        this.shuffle.filter((element, shuffle) => {
            // If there is a current filter applied, ignore elements that don't match it.
            if (shuffle.group !== Shuffle.ALL_ITEMS) {
                // Get the item's groups.
                const groups = JSON.parse(element.getAttribute('data-groups'));
                const isElementInCurrentGroup = groups.indexOf(shuffle.group) !== -1;
                // Only search elements in the current group
                if (!isElementInCurrentGroup) {
                    return false;
                }
            }
            const titleElement = element.querySelector('.picture-item__title');
            const titleText = titleElement.textContent.toLowerCase().trim();
            return titleText.indexOf(searchText) !== -1;
        });
    }
}


document.addEventListener('DOMContentLoaded', () => {
    window.gallery = new Gallery(document.getElementById('grid'));
});
document.addEventListener('DOMContentLoaded', () => {
    window.gallery = new GalleryVideo(document.getElementById('grid-video'));
});

let isClickedLoadMore = false;
let actualVisibleCard; 
let actualSizeOfGridAfterClick = 0;
let gridHeight = document.getElementById('grid').clientHeight;
let countCardsLoad = 15;
let number = window.matchMedia("(max-width: 767px)");
let heightOfVisibleGridOnClick;
let heightOfVisibleGrid;
let gridWrapper;
let arrOfHeight = [];

function loadMore(){
        countHiddenCardsResponsive(number);
        number.addListener(countHiddenCardsResponsive);

        if(isClickedLoadMore == false){
            $('#grid .shuffle-item--visible').slice(countCardsLoad).addClass('hidden-card');
            $('#grid .shuffle-item--visible').slice(0,countCardsLoad).addClass('visible-card');
        }
        if(isClickedLoadMore == true){
            console.log(actualVisibleCard,"actualVisibleCard in slice");  
            $('#grid .shuffle-item--visible').slice(actualVisibleCard).addClass('hidden-card');
            $('#grid .shuffle-item--visible').slice(0,actualVisibleCard).addClass('visible-card');
        }

        let galleryItems = document.querySelectorAll('.picture-item');
 
        let styleItems = window.getComputedStyle ? getComputedStyle(galleryItems[0], null) : galleryItems[0].currentStyle;
        let marginTop = parseInt(styleItems.marginTop) || 0;
        let marginBottom = parseInt(styleItems.marginBottom) || 0;
        let paddingTop = parseInt(styleItems.paddingTop) || 0;
        let paddingBottom = parseInt(styleItems.paddingBottom) || 0;

        let totalPaddingMargin = (marginTop + marginBottom + paddingTop + paddingBottom);

        let visibleCards = document.querySelectorAll('#grid .visible-card');
        for (let i = 0; i < visibleCards.length; i++) { 
            visibleCards[visibleCards.length -1].classList.add('last-visible-card');
            visibleCards[0].classList.add('first-visible-card');
        }  
        heightOfVisibleGrid = ($("#grid .last-visible-card").offset().top) + ($("#grid .last-visible-card").outerHeight())-(($("#grid .first-visible-card" ).offset().top)) + marginBottom + 1;

        arrOfHeight.push(heightOfVisibleGrid);
        console.log(arrOfHeight); 

        heightOfVisibleGrid = arrOfHeight[0];

        console.log(heightOfVisibleGrid,'heightOfVisibleGrid');  
        
        gridWrapper = document.querySelectorAll('.grid-wrapper')[0];
        gridWrapper.style.height = heightOfVisibleGrid + 'px';

        if(isClickedLoadMore == true){
            console.log(actualSizeOfGridAfterClick,'actualSizeOfGridAfterClick gridWrapper.style.height'); 
            gridWrapper.style.height = actualSizeOfGridAfterClick + 'px';
            if($('#grid .shuffle-item--visible.hidden-card').length == 0){
                gridWrapper.style.height = gridHeight + 'px';
                console.log(gridHeight,'gridHeight if length 0'); 
            }
        }
        console.log(gridHeight,'gridHeight on load'); 

        heightOfVisibleGridOnClick = heightOfVisibleGrid;
        if(isClickedLoadMore == true){
            heightOfVisibleGridOnClick = actualSizeOfGridAfterClick;
            console.log(heightOfVisibleGridOnClick,''); 
        }

        console.log($('#grid .shuffle-item--visible.hidden-card').length,'#grid .shuffle-item--visible.hidden-card');  
        if($('#grid .shuffle-item--visible.hidden-card').length > 0) {
            $('#loadMoreGallery').removeClass('d-none');
        }

        $(".visible-card:first-child").addClass('first');
        $(".visible-card:last-child" ).addClass('last');

        function countHiddenCardsResponsive(number) {
            if (number.matches) { // If media query matches
                countCardsLoad = 8;
                countCardsLoadMore = 8;
            }
        }
}

$('#loadMoreGallery').on('click', function(e){
    e.preventDefault();
    isClickedLoadMore = true;
    $('#grid .shuffle-item--visible.hidden-card').slice(0, countCardsLoad).removeClass('hidden-card').addClass('d-block visible-card');

    console.log(countCardsLoad); 


    if($('#grid .shuffle-item--visible.hidden-card').length == 0) {
        $('#loadMoreGallery').addClass('d-none');
        gridWrapper.style.height = gridHeight + 'px';
    }else{
        heightOfVisibleGridOnClick = heightOfVisibleGridOnClick + (heightOfVisibleGrid);
        gridWrapper.style.height = heightOfVisibleGridOnClick + 'px';
        actualSizeOfGridAfterClick = heightOfVisibleGridOnClick;
        console.log(actualSizeOfGridAfterClick,'actualSizeOfGridAfterClick'); 
        if(isClickedLoadMore) {

        }
    }
    actualVisibleCard = $('#grid .shuffle-item--visible.visible-card').length;
    console.log(actualVisibleCard,'actualVisibleCard');  
    console.log(isClickedLoadMore,'isClickedLoadMore'); 
});

function loadMoreClickNav(){
    let gridWrapper = document.querySelectorAll('.grid-wrapper')[0];
    gridWrapper.style.height = '100%';
    $('#grid .shuffle-item').removeClass('hidden-card'); 
    $('#loadMoreGallery').addClass('d-none');
}
  